export const NATIONALITIES = [
  { id: 'FR', label: 'Française' },
  { id: 'CH', label: 'Suisse' },
  { id: 'BE', label: 'Belge' },
  { id: 'DE', label: 'Allemande' },
  { id: 'IT', label: 'Italienne' },
  { id: 'AF', label: 'Afghane' },
  { id: 'AL', label: 'Albanaise' },
  { id: 'DZ', label: 'Algérienne' },
  { id: 'US', label: 'Américaine' },
  { id: 'AD', label: 'Andorrane' },
  { id: 'AO', label: 'Angolaise' },
  { id: 'AG', label: 'Antiguaise et Barbudienne' },
  { id: 'AR', label: 'Argentine' },
  { id: 'AM', label: 'Arménienne' },
  { id: 'AU', label: 'Australienne' },
  { id: 'AT', label: 'Autrichienne' },
  { id: 'AZ', label: 'Azerbaïdjanaise' },
  { id: 'BS', label: 'Bahamienne' },
  { id: 'BH', label: 'Bahreinienne' },
  { id: 'BD', label: 'Bangladaise' },
  { id: 'BB', label: 'Barbadienne' },
  { id: 'BZ', label: 'Bélizienne' },
  { id: 'BJ', label: 'Béninoise' },
  { id: 'BT', label: 'Bhoutanaise' },
  { id: 'BY', label: 'Biélorusse' },
  { id: 'MM', label: 'Birmane' },
  { id: 'GW', label: 'Bissau-Guinéenne' },
  { id: 'BO', label: 'Bolivienne' },
  { id: 'BA', label: 'Bosnienne' },
  { id: 'BW', label: 'Botswanaise' },
  { id: 'BR', label: 'Brésilienne' },
  { id: 'UK', label: 'Britannique' },
  { id: 'BN', label: 'Brunéienne' },
  { id: 'BG', label: 'Bulgare' },
  { id: 'BF', label: 'Burkinabe' },
  { id: 'BI', label: 'Burundaise' },
  { id: 'KH', label: 'Cambodgienne' },
  { id: 'CM', label: 'Camerounaise' },
  { id: 'CA', label: 'Canadienne' },
  { id: 'CV', label: 'Cap-verdienne' },
  { id: 'CF', label: 'Centrafricaine' },
  { id: 'CL', label: 'Chilienne' },
  { id: 'CN', label: 'Chinoise' },
  { id: 'CY', label: 'Chypriote' },
  { id: 'CO', label: 'Colombienne' },
  { id: 'KM', label: 'Comorienne' },
  { id: 'CG', label: 'Congolaise' },
  { id: 'CR', label: 'Costaricaine' },
  { id: 'HR', label: 'Croate' },
  { id: 'CU', label: 'Cubaine' },
  { id: 'CW', label: 'Curaçaoane' },
  { id: 'DK', label: 'Danoise' },
  { id: 'DJ', label: 'Djiboutienne' },
  { id: 'DO', label: 'Dominicaine' },
  { id: 'DM', label: 'Dominiquaise' },
  { id: 'EG', label: 'Egyptienne' },
  { id: 'AE', label: 'Emirienne' },
  { id: 'GQ', label: 'Equato-guinéenne' },
  { id: 'EC', label: 'Equatorienne' },
  { id: 'ER', label: 'Erythreenne' },
  { id: 'ES', label: 'Espagnole' },
  { id: 'TL', label: 'Est-timoraise' },
  { id: 'EE', label: 'Estonienne' },
  { id: 'ET', label: 'Ethiopienne' },
  { id: 'FJ', label: 'Fidjienne' },
  { id: 'FI', label: 'Finlandaise' },
  { id: 'GA', label: 'Gabonaise' },
  { id: 'GM', label: 'Gambienne' },
  { id: 'GE', label: 'Géorgienne' },
  { id: 'GH', label: 'Ghanéenne' },
  { id: 'GD', label: 'Grenadienne' },
  { id: 'GT', label: 'Guatémaltèque' },
  { id: 'GN', label: 'Guinéenne' },
  { id: 'GY', label: 'Guyanienne' },
  { id: 'HT', label: 'Haïtienne' },
  { id: 'GR', label: 'Hellénique' },
  { id: 'HN', label: 'Hondurienne' },
  { id: 'HU', label: 'Hongroise' },
  { id: 'IN', label: 'Indienne' },
  { id: 'ID', label: 'Indonésienne' },
  { id: 'IQ', label: 'Irakienne' },
  { id: 'IE', label: 'Irlandaise' },
  { id: 'IS', label: 'Islandaise' },
  { id: 'IL', label: 'Israélienne' },
  { id: 'CI', label: 'Ivoirienne' },
  { id: 'JM', label: 'Jamaïcaine' },
  { id: 'JP', label: 'Japonaise' },
  { id: 'JO', label: 'Jordanienne' },
  { id: 'KZ', label: 'Kazakhstanaise' },
  { id: 'KE', label: 'Kényane' },
  { id: 'KG', label: 'Kirghize' },
  { id: 'KI', label: 'Kiribatienne' },
  { id: 'KN', label: 'Kittitienne-et-nevicienne' },
  { id: 'XK', label: 'Kossovienne' },
  { id: 'KW', label: 'Koweitienne' },
  { id: 'LA', label: 'Laotienne' },
  { id: 'LS', label: 'Lesothane' },
  { id: 'LV', label: 'Lettone' },
  { id: 'LB', label: 'Libanaise' },
  { id: 'LR', label: 'Libérienne' },
  { id: 'LY', label: 'Libyenne' },
  { id: 'LI', label: 'Liechtensteinoise' },
  { id: 'LT', label: 'Lituanienne' },
  { id: 'LU', label: 'Luxembourgeoise' },
  { id: 'MK', label: 'Macédonienne' },
  { id: 'MY', label: 'Malaisienne' },
  { id: 'MW', label: 'Malawienne' },
  { id: 'MV', label: 'Maldivienne' },
  { id: 'MG', label: 'Malgache' },
  { id: 'ML', label: 'Malienne' },
  { id: 'MT', label: 'Maltaise' },
  { id: 'MA', label: 'Marocaine' },
  { id: 'MH', label: 'Marshallaise' },
  { id: 'MU', label: 'Mauricienne' },
  { id: 'MR', label: 'Mauritanienne' },
  { id: 'MX', label: 'Mexicaine' },
  { id: 'FM', label: 'Micronesienne' },
  { id: 'MD', label: 'Moldave' },
  { id: 'MC', label: 'Monegasque' },
  { id: 'MN', label: 'Mongole' },
  { id: 'ME', label: 'Monténégrine' },
  { id: 'MZ', label: 'Mozambicaine' },
  { id: 'NA', label: 'Namibienne' },
  { id: 'NR', label: 'Nauruane' },
  { id: 'NL', label: 'Néerlandaise' },
  { id: 'NZ', label: 'Neo-zélandaise' },
  { id: 'NP', label: 'Népalaise' },
  { id: 'NI', label: 'Nicaraguayenne' },
  { id: 'NG', label: 'Nigériane' },
  { id: 'NE', label: 'Nigérienne' },
  { id: 'KP', label: 'Nord-coréenne' },
  { id: 'NO', label: 'Norvégienne' },
  { id: 'OM', label: 'Omanaise' },
  { id: 'UG', label: 'Ougandaise' },
  { id: 'UZ', label: 'Ouzbèke' },
  { id: 'PK', label: 'Pakistanaise' },
  { id: 'PW', label: 'Palau' },
  { id: 'PS', label: 'Palestinienne' },
  { id: 'PA', label: 'Panaméenne' },
  { id: 'PG', label: 'Papouane-neoguinéenne' },
  { id: 'PY', label: 'Paraguayenne' },
  { id: 'PE', label: 'Péruvienne' },
  { id: 'PH', label: 'Philippine' },
  { id: 'PL', label: 'Polonaise' },
  { id: 'PR', label: 'Portoricaine' },
  { id: 'PT', label: 'Portugaise' },
  { id: 'QA', label: 'Qatarienne' },
  { id: 'RO', label: 'Roumaine' },
  { id: 'RU', label: 'Russe' },
  { id: 'RW', label: 'Rwandaise' },
  { id: 'LC', label: 'Saint-Lucienne' },
  { id: 'SM', label: 'Saint-Marinaise' },
  { id: 'SX', label: 'Saint-Martinoise' },
  { id: 'VC', label: 'Saint-Vincentaise-et-Grenadine' },
  { id: 'SB', label: 'Salomonaise' },
  { id: 'SV', label: 'Salvadorienne' },
  { id: 'WS', label: 'Samoane' },
  { id: 'ST', label: 'Santoméenne' },
  { id: 'SA', label: 'Saoudienne' },
  { id: 'SN', label: 'Sénégalaise' },
  { id: 'SS', label: 'Sud-Soudanaise' },
  { id: 'RS', label: 'Serbe' },
  { id: 'SC', label: 'Seychelloise' },
  { id: 'SL', label: 'Sierra-leonaise' },
  { id: 'SG', label: 'Singapourienne' },
  { id: 'SK', label: 'Slovaque' },
  { id: 'SI', label: 'Slovene' },
  { id: 'SO', label: 'Somalienne' },
  { id: 'SD', label: 'Soudanaise' },
  { id: 'LK', label: 'Sri-lankaise' },
  { id: 'ZA', label: 'Sud-africaine' },
  { id: 'KR', label: 'Sud-coréenne' },
  { id: 'SE', label: 'Suédoise' },
  { id: 'SR', label: 'Surinamaise' },
  { id: 'SZ', label: 'Swazie' },
  { id: 'SY', label: 'Syrienne' },
  { id: 'TJ', label: 'Tadjike' },
  { id: 'TW', label: 'Taïwanaise' },
  { id: 'TZ', label: 'Tanzanienne' },
  { id: 'TD', label: 'Tchadienne' },
  { id: 'CZ', label: 'Tchèque' },
  { id: 'TH', label: 'Thaïlandaise' },
  { id: 'TG', label: 'Togolaise' },
  { id: 'TO', label: 'Tonguienne' },
  { id: 'TT', label: 'Trinidadienne' },
  { id: 'TN', label: 'Tunisienne' },
  { id: 'TM', label: 'Turkmène' },
  { id: 'TR', label: 'Turque' },
  { id: 'TV', label: 'Tuvaluane' },
  { id: 'UA', label: 'Ukrainienne' },
  { id: 'UY', label: 'Uruguayenne' },
  { id: 'VA', label: 'Vaticane' },
  { id: 'VU', label: 'Vanuatuane' },
  { id: 'VE', label: 'Vénézuelienne' },
  { id: 'VN', label: 'Vietnamienne' },
  { id: 'YE', label: 'Yemenite' },
  { id: 'ZM', label: 'Zambienne' },
  { id: 'ZW', label: 'Zimbabwéenne' },
];
